import { Component, HostListener, OnInit, OnDestroy, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { ApiService } from 'src/app/services/api.service';
import { DashboardBusinessLogicService } from 'src/app/services/dashboard-business-logic.service';
import { GenesysCloudService } from 'src/app/services/genesys-cloud.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from '../../../models/Constants';

@Component({
  selector: 'app-alis-registration',
  templateUrl: './alis-registration.component.html',
  styleUrls: ['./alis-registration.component.scss'],
})
export class ALISRegistrationComponent implements OnInit, OnDestroy {
  // Below code to be used and to be removed from multiple places once all the dropdowns are made common.
  @ViewChild(MatSelect) select!: MatSelect;
  @HostListener('window:scroll', [])
  onScroll(): void {
    if (this.select.panelOpen) {
      this.select.close();
    }
  }
  disableRegisterButton: boolean = false;
  ALISRegistration!: FormGroup;
  registeredRegion: any;
  cloudRegistrationMsg: string = Constants.CLOUD_REGISTRATION_MSG;
  loadPopup: boolean = false;
  alisRegionListLoader: boolean = false;
  /* Below varible contains the prefrenceRegionObj */
  showLoaderMsg: boolean = false;
  loaderTimeoutId: any;
  loaderType = Constants.LOADER_TYPE.CARD;

  constructor(
    public rootScope: RootScopeService,
    public genesysCloudService: GenesysCloudService,
    public dashboardService: DashboardBusinessLogicService,
    public apiService: ApiService,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.createALISRegistrationForm();
    this.registedALISRegion();
  }


  /**Below method create the reactive form for ALIS registration */
  createALISRegistrationForm() {
    this.ALISRegistration = this.fb.group({
      region: new FormControl(null, Validators.required),
    });
  }

  /**Below method take the data of selected region from dropdown and
   * set it in rootScope Service _ALISSelectedRegionObj Observable and if
   * user select the registered region from dropdown then register button remain disable
   * and rest of others regions it will enabled to register.
   */
  selectedRegionObj(event) {
    sessionStorage.setItem('pref_region', event.region);
    sessionStorage.setItem('selectedRegion', event.region);
    this.rootScope.selectedALISRegion = event.region;
    this.rootScope._ALISSelectedRegionObj.next(event);
    let clientID = this.rootScope.getObjFromConfigObj(event.region + Constants.ALIS_CLIENT_ID);
    if (clientID) {
      this.rootScope.GENESYS_CLOUD_CLIENT_ID = clientID.fieldValue;
      sessionStorage.setItem('ALIS_CLIENT_ID', clientID.fieldValue);
    }
    if (this.rootScope.preferenceRegion != 'undefined' && event?.region != this.rootScope.preferenceRegion) {
      this.rootScope.ALISChangeOrgInfoMsg = true;
      this.rootScope.ALISRegistrationCardError = false;
      this.rootScope.ALISRegistrationCardSuccess = false;
      this.rootScope.ALISTrainingTestingSuccessMsg = false;
      this.disableRegisterButton = false;


    }
    else {
      this.disableRegisterButton = false;
      this.rootScope.ALISTrainingTestingInfoMsg = false;
      this.rootScope.ALISChangeOrgInfoMsg = false;
      this.rootScope.ALISTrainingTestingSuccessMsg = false;
      this.rootScope.ALISRegistrationCardSuccess = false;

    }
  }

  /**Below method literally compares objects by some given values
   *and the dropdown get selected, if it returns true  */

  compareFunction(o1: any, o2: any) {
    return o1?.displayName == o2?.displayName && o1?.region == o2?.region;
  }

  /**Below method check if CarePortal is registered with specific region with the ALIS then
   *  it took the value of registered region and set it in dropdownlist and disable the
   * register button for that specific registered region.
   */

  registedALISRegion() {
    if (sessionStorage.hasOwnProperty('ALISRegisteredRegionObj')) {
      let sessionRegisteredRegion: any = sessionStorage.getItem(
        'ALISRegisteredRegionObj'
      );
      if (sessionRegisteredRegion) {
        this.registeredRegion = JSON.parse(sessionRegisteredRegion);
        this.disableRegisterButton = true;
        this.ALISRegistration?.get('region')?.setValue(this.registeredRegion);
        sessionStorage.setItem('pref_region', this.registeredRegion?.region);
      }
    }
  }


  /**Below method handle the Submit button and
   * the button would be enabled when the form is valid.  */

  onSubmit() {
    if (this.ALISRegistration?.invalid) {
      return;
    } else {
      this.promptALISRegistrationPopup();
    }
  }

  /**Below method handle the region selected value and open the Dialog Box for
   * ALIS registration and it pass the value of selected region url to observable
   * created in Genesys Cloud Service.  */

  promptALISRegistrationPopup() {
    if (this.rootScope.prefrenceRegionObj?.displayName == 'Testing/Training') {
      this.rootScope.ALISTrainingTestingSuccessMsg = true;
      this.rootScope.ALISTrainingTestingInfoMsg = false;
      this.rootScope.ALISChangeOrgInfoMsg = false;

      if (this.rootScope.ALISTrainingTestingSuccessMsg == true) {
        this.disableRegisterButton = true;
      }
    }
    else {
      let fieldName = this.ALISRegistration?.value?.region?.region + '_AUTH_URL';
      let regionObj = this.rootScope.getObjFromConfigObj(fieldName);
      if (regionObj != null && regionObj != undefined) {
        let region: any = regionObj?.fieldValue;
        // console.log('Selected region =' + region);
        sessionStorage.setItem('ALIS_region', region);
        this.genesysCloudService?._environment.next(region);
        /**
         * @author Vamsi Pamidala
         * for updating client id in root service level
         */
        const alisClientID = this.rootScope.getObjFromConfigObj(region + Constants.ALIS_CLIENT_ID);

        if (alisClientID) {
          this.rootScope.GENESYS_CLOUD_CLIENT_ID = alisClientID?.fieldValue;
          sessionStorage.setItem('ALIS_CLIENT_ID', alisClientID?.fieldValue);
        }
        /* @vamsi.pamidala 
        set customer account and customer search data in session storage */

        let tabDetails = {
          customerSearchData: this.rootScope?.customerSearchForm?.value,
          resultData: this.rootScope?.dataSource?.filteredData,
          customerLink: this.rootScope.customerLink,
          clientId: this.rootScope.dashboardForm.get('clientId')?.value,
          clientNameDash: this.rootScope.getClientName(this.rootScope.dashboardForm.get('clientId')?.value)
        };
        sessionStorage.setItem('customerTabs', JSON.stringify(tabDetails));
        sessionStorage.setItem('ALISRegistration', 'true');
        //sessionStorage.setItem('pref_region', this.rootScope.selectedALISRegion);
        //added for CCR5-1004
        const selectedRegion = this.rootScope.prefrenceRegionObj?.region;
        if(selectedRegion ){
          sessionStorage.setItem('selectedRegion', selectedRegion);
        }
        this.registerNow();

      }
    }
  }
  /**Below method is used to Close the Success Alert message on click of cross icon  */
  closeSuccess() {
    this.rootScope.ALISRegistrationCardSuccess = false;
  }
  /* Below goToALIS() method open the ALIS application */
  goToALIS() {
    let Url = Constants.ALIS_LOGIN_URL;

    // switch (this.ALISRegistration?.value.region?.region) {
    //   case "EMEA":
    //     Url = Constants.EMEA_ALIS_LOGIN_URL;
    //     break;

    //   default: Url = Constants.ALIS_LOGIN_URL;
    //     break;
    // }


    this.rootScope.openNewTab(Url);
  }



  /* Below registerNow() method called when Register Button on Click for register care portal to ALIS */
  
  registerNow() {
    // console.log('registerNow method called');

    let usrPayload = {
      "isAlisRegistered": true
    }
    if (this.rootScope.simulationData.isSimulationModeActive) {
      this.rootScope.openDialog({
        title: '',
        subheading: '',
        message: "Registering to ALIS is not permitted while Simulation Mode is on. Complete all Simulations in progress and exit Simulation Mode.",
        firstbutton: '',
        secondbutton: Constants.buttonEnum.gotIt,
        crossIcon: false,
        comingFrom: 'dashboard',
        additionalClass: 'end-register',
      });
    }
    else {
      this.genesysCloudService.prepareRegistrationAuthWindow();
      this.rootScope._ALISSelectedRegionObj.subscribe((res) => {
        sessionStorage.setItem('ALISRegisteredRegionObj', JSON.stringify(res));
        this.rootScope.updateUserInElasticCache(usrPayload);
        sessionStorage.setItem('connectToGenesys', 'true');
        this.genesysCloudService.sendMessage(true);
      },
        (error) => {
          this.genesysCloudService.closeRegistrationAuthWindow();
          console.log('Error logging in genesys ' + error);
        }
      );
      this.rootScope.closeALSTab();

    }


  }

  enableDisableRegisterButton() {
    if (this.rootScope.isGenesysLoggedIn || !this.ALISRegistration?.get('region')?.value || this.rootScope.isLiveCall || this.rootScope.isLiveChat) {
      return true;
    }
    return false;
  }

  enableDisableEndRegisterButton() {
    if (!this.rootScope.isGenesysLoggedIn || this.rootScope.isLiveCall || !this.ALISRegistration?.get('region')?.value || this.rootScope.isLiveChat) {
      return true;
    }
    return false;
  }

  disableOrgDropDown() {
    if (this.rootScope.isGenesysLoggedIn || this.rootScope.isLiveCall || this.rootScope.isLiveChat) {
      this.ALISRegistration.get('region')?.disable();
      return true;
    }
    this.ALISRegistration.get('region')?.enable();
    return false;
  }

 
  endRegistration() {
    if (this.enableDisableEndRegisterButton()) {
      return;
    }
    if (this.rootScope.customerTabs?.length > 1) {
      this.rootScope.openDialog({
        title: '',
        subheading: '',
        message: "Close all customer accounts before ending registration.",
        firstbutton: '',
        secondbutton: Constants.buttonEnum.gotIt,
        crossIcon: false,
        comingFrom: 'dashboard',
        additionalClass: 'end-register',
      });
    }
    else {
      /**Added for CCR1-7444 */
      this.apiService.genesysLogout(this.rootScope.invalidENVBanner);
    }
  }

  ngOnDestroy() {
    clearTimeout(this.loaderTimeoutId);
    clearTimeout(this.rootScope.alisRegistrationLoaderTimeoutId);
    this.rootScope.showAlisRegistrationLoaderMsg = false;
    this.rootScope.alisRegistrationLoader = false;
  }
}
